import { z } from 'zod';

export const ScheduleObligationRequest = z.object({
  chain_id: z.string().min(1).max(40),
  source_action_id: z.string().min(1).max(40).optional(),
  title: z.string().trim().min(1).max(300),
  owner_kind: z.enum(['owner', 'staff', 'system']),
  due_at: z.string().datetime({ offset: true }),
  resolution_policy: z.enum([
    'explicit_confirmation',
    'dependency_resolution',
    'provider_callback',
    'evidence_review',
  ]),
  obligation_kind: z
    .enum(['follow_up', 'installation', 'maintenance', 'replacement'])
    .default('follow_up'),
  responsible_user_id: z.string().min(1).max(40).optional(),
  next_expected_event: z.string().trim().min(1).max(300).optional(),
  max_escalations: z.number().int().min(0).max(3).default(1),
  idempotency_key: z.string().min(8).max(120),
});

export const ObligationJobPayloadV1 = z.object({
  version: z.literal(1),
  outbox_id: z.string().min(1).max(40),
  obligation_id: z.string().min(1).max(40),
  household_id: z.string().min(1).max(40),
});

export type ScheduleObligationInput = z.infer<typeof ScheduleObligationRequest>;
export type ObligationJobPayload = z.infer<typeof ObligationJobPayloadV1>;

export const CreateWaitRequest = z.object({
  chain_id: z.string().min(1).max(40),
  action_id: z.string().min(1).max(40).optional(),
  reason_code: z.enum([
    'provider_callback',
    'delivery',
    'owner_decision',
    'worker_handoff',
    'dependency',
    'scheduled_date',
  ]),
  responsible_kind: z.enum(['owner', 'worker', 'provider', 'system']),
  responsible_user_id: z.string().min(1).max(40).optional(),
  next_expected_event: z.string().trim().min(1).max(300),
  expected_resolution_at: z.string().datetime({ offset: true }),
  max_escalations: z.number().int().min(0).max(3).default(1),
});
export const EvaluateFollowThroughRequest = z.object({
  now: z.string().datetime({ offset: true }).optional(),
});
export const ResolveAttentionRequest = z.object({
  decision: z.enum(['acknowledge', 'reschedule', 'cancel', 'resolve']),
  expected_resolution_at: z.string().datetime({ offset: true }).optional(),
  reason: z.string().trim().min(1).max(500),
  expected_revision: z.number().int().min(1),
});
export type CreateWaitInput = z.infer<typeof CreateWaitRequest>;
export type EvaluateFollowThroughInput = z.infer<typeof EvaluateFollowThroughRequest>;
export type ResolveAttentionInput = z.infer<typeof ResolveAttentionRequest>;
